<template>
  <div>
    <general-table :loading="loading" :type="'load'" :items="items" @select="onSelect" />
    <v-dialog :max-width="900" :value="selectedId !== null" @input="selectedId = null">
      <mixer-loads-detail :selected="selectedItem" @close="selectedId = null" />
    </v-dialog>
    <ui-pagination v-if="showPagination" v-model="page" :page-count="pageCount" @page-change="pageChangeHandler">
    </ui-pagination>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import UiPagination from '@/components/ui/ui-pagination/UiPagination.vue'
import GeneralTable from '../general-table/GeneralTable'
import MixerLoadsDetail from './MixerLoadsDetail'
import { getDateForDatePicker } from '@/util'
import paginationMixin from '@/mixins/pagination.mixin'
export default {
  name: 'MixerLoadsList',
  components: {
    MixerLoadsDetail,
    GeneralTable,
    UiPagination
  },

  data: () => ({
    selectedId: null,
    watchFilters: true
  }),
  mixins: [paginationMixin],
  computed: {
    ...mapGetters('reports', [
      'load',
      'filters',
      'totalCount',
    ]),

    selectedItem () {
      return this.items.find(item => item.id === this.selectedId)
    },

    allowView () {
      return this.hasPermission('load', 'view')
    },
    timezone () {
      return this.$store.getters['account/timezone']
    },
  },

  async mounted () {
    const farmId = this.$route.params.farm_id
    sessionStorage.removeItem(`reports_${farmId}_loads`)
    this.watchFilters = false

    const hasDateFilters = this.filters.planned_on_before && this.filters.planned_on_after
    /* eslint-disable camelcase */
    const today = getDateForDatePicker(this.timezone)
    const planned_on_before = hasDateFilters ? this.filters.planned_on_before : today
    const planned_on_after = hasDateFilters ? this.filters.planned_on_after : today

    const baseFilters = {
      planned_on_before,
      planned_on_after,
      farm: farmId
    }
    /* eslint-enable camelcase */
    const fullFilters = hasDateFilters
      ? {
        ...baseFilters,
        group: [],
        animal_type: [],
        ration: [],
        loading: [],
        status: [],
        loaded_time_max: null,
        loaded_time_min: null
      }
      : baseFilters

    this.$store.dispatch('reports/applyFilters', fullFilters)

    await this.setupPagination(
      api.reports.load.list,
      {
        ...baseFilters,
        page: this.page > 1 ? this.page : 1
      },
      `reports_${farmId}_loads`
    )
    this.$store.dispatch('reports/applyTotal', this.pageCount)
    this.watchFilters = true
  },

  methods: {
    // ...mapActions('reports', [
    //   'getLoad'
    // ]),

    onSelect (item) {
      this.selectedId = item.id
    },
  },
  watch: {
    filters: {
      async handler () {
        if (this.watchFilters) {
          await this.$router.push({
            query: {
              ...this.$route.query,
              page: 1
            }
          })
          if (!this.filters.planned_on_before && !this.filters.planned_on_after) {
            const today = getDateForDatePicker(this.timezone)
            this.$store.dispatch('reports/applyFilters', {
              planned_on_before: today,
              planned_on_after: today,
              farm: this.$route.params.farm_id
            })
          }
          await this.setupPagination(
            api.reports.load.list,
            {
              farm: this.$route.params.farm_id,
              ...this.filters,
              page: 1
            },
            `reports_${this.$route.params.farm_id}_loads`
          )
          this.$store.dispatch('reports/applyTotal', this.pageCount)
        }
      },
      deep: true
    }
  }



}
</script>
